import React, { useEffect, useRef } from "react";
import photo1 from './../assets/photos/photo1.jpeg';
import photo2 from './../assets/photos/photo2.jpeg';
import photo3 from './../assets/photos/photo3.jpeg';
import "./NotFound.css";

const NotFound = () => {
  const photos = [
    photo1, 
    photo2, 
    photo3
    // Add more paths to your photos here
  ];

  const containerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const container = containerRef.current;
      if (!container) return;

      const { clientX, clientY } = event;
      const { width, height } = container.getBoundingClientRect();

      const offsetX = (clientX / width - 0.5) * 20; // Cursor parallax effect
      const offsetY = (clientY / height - 0.5) * 20;

      container.style.setProperty("--offset-x", `${offsetX}px`);
      container.style.setProperty("--offset-y", `${offsetY}px`);
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="not-found-container" ref={containerRef}>
      <h1 className="not-found-message">404 Not Found</h1>
      <div className="photo-container">
        {photos.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Floating ${index}`}
            className="floating-photo"
            style={{
              transform: `translate(var(--offset-x, 0), var(--offset-y, 0))`
            }}
          />
        ))}
      </div>
      <div className="stars"></div>
      <div className="shooting-stars">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="shooting-star"></div>
        ))}
      </div>
    </div>
  );
};

export default NotFound;